import { render, staticRenderFns } from "./PorAnoAtoInfralegal.vue?vue&type=template&id=2173496a&scoped=true"
import script from "./PorAnoAtoInfralegal.vue?vue&type=script&lang=js"
export * from "./PorAnoAtoInfralegal.vue?vue&type=script&lang=js"
import style0 from "./PorAnoAtoInfralegal.vue?vue&type=style&index=0&id=2173496a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2173496a",
  null
  
)

export default component.exports